import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { DefaultContainer } from '../../../../modal/detail-modal/default-container/default-container';
import { usePersonalQrCodeCard } from './personal-qr-code-card.controller';

export interface PersonalQrCodeCardProps {
    entity_id: string;
}

export const PersonalQrCodeCard = (props: PersonalQrCodeCardProps) => {
    const viewProps = usePersonalQrCodeCard(props);
    return (
        <DefaultContainer
            title={
                <FormattedMessage
                    id='personal-qr-code-card.title'
                    defaultMessage='Personal QR code'
                    description='Title for the personal QR code card'
                />
            }
            content={
                viewProps.isLoading ? (
                    <Spinner />
                ) : (
                    <div className='inline-flex flex-col items-start justify-start gap-4 self-stretch'>
                        <div className='text-foreground-default justify-start text-base font-medium'>
                            <FormattedMessage
                                id='personal-qr-code-card.description'
                                defaultMessage='The personal QR code allows users to authenticate themselves on the kiosk using a QR code on the mobile app.'
                                description='Description of what the personal QR code does'
                            />
                        </div>

                        <span
                            className={`text-background-surface inline-flex items-start justify-center rounded-full px-2 py-1 ${viewProps.enabled ? 'bg-status-success' : 'bg-status-warning'}`}>
                            <span className='text-always-white justify-start text-center text-sm font-semibold'>
                                {viewProps.enabled ? CommonMessage.OBJECTS.COMMON_FIELDS.ENABLED : CommonMessage.OBJECTS.COMMON_FIELDS.DISABLED}
                            </span>
                        </span>
                    </div>
                )
            }
        />
    );
};
